<div class="contacts">

  <div class="info-item">

    <h2>Наш магазин</h2>
    <div class="text-info">
      <a href="{{addressLink}}" target="_blank">{{shopAddress}}</a>
    </div>
    <div class="text-info" [innerHTML] = "workTime"> </div>

  </div>
  <div class="info-item">

    <h2>Телефон</h2>
    <div class="text-info" >{{phone}} </div>
  </div>
  <div class="info-item">

    <h2>email</h2>

    <div class="text-info">
      <a href="mailto:{{email}}" >{{email}}</a>
    </div>
  </div>

</div>
